import {
  ReferencesCard
} from 'lib-core'


export default ReferencesCard
